import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Box,
  Grid,
  Button,
  Divider,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";

import { esignToolApi } from "../../services/esignApi";
import { CallingPhoneIcon, EmailIcon } from "../../assets/icons";

const HelpSupport = () => {
  const [formData, setFormData] = useState({
    title: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setFormData({
      title: "",
      message: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitHandler = async () => {
    setLoading(true);
    try {
      const response = await esignToolApi.sendFeedback(formData);
      toast.success("Your request has been sent successfully.");
      resetForm();
    } catch (err) {
      console.error("Error:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = loading || !formData.title.trim() || !formData.message.trim() || formData.title.trim().length < 20 || formData.message.trim().length < 50;

  return (
    <>
      <Box sx={{ width: "76%" }}>
        <Box sx={{ p: "22px 30px", textAlign: "left" }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#393939",
            }}
          >
            Help & Support
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "20px",
              color: "#5C5C5C",
              mt: "20px",
            }}
          >
            We're here to help—whether you're just getting started, need service info, or technical support.
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            p: "20px 30px",
            height: "calc(100% - 180px)",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              mb: 3,
              display: "flex",
              alignItems: "center",
              height: 60,
              maxWidth: "fit-content",
              border: "1px solid #C0C0C0",
              borderRadius: "12px",
              px: 2,
              backgroundColor: "#fff",
            }}
          >
            {/* Phone */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CallingPhoneIcon />
              <Typography sx={{ fontSize: "16px" }}>
                +91 8920 769 736
              </Typography>
            </Box>

            {/* Divider */}
            <Box
              sx={{
                height: "60%",
                mx: 2,
                borderLeft: "1px solid #C0C0C0",
              }}
            />

            {/* Email */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmailIcon color={"#1A73E8"} />
              <Typography sx={{ fontSize: "16px" }}>
                support@meon.co.in
              </Typography>
            </Box>
          </Box>

          <Grid
            container
            rowSpacing={3}
            sx={{ flexDirection: "column !important" }}
          >
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                name="title"
                placeholder="Enter title"
                value={formData.title}
                onChange={handleChange}
                sx={{
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    height: "56px",
                    borderColor: "#C0C0C0",
                    backgroundColor: "none",
                    "&:hover fieldset": {
                      borderColor: "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  sx: {
                    borderRadius: "10px",
                    fontSize: "16px",
                    fontWeight: "400",
                  },
                }}
                inputProps={{ maxLength: 200 }}
              />
              <Box sx={{ display: "flex", justifyContent: "space-between"}}>
                <Typography sx={{ fontSize: "12px", textAlign: "end",  }}>(min 20 characters)</Typography>
                <Typography sx={{ fontSize: "12px", textAlign: "end",  }}>(max 200 characters)</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                multiline
                rows={7}
                name="message"
                placeholder="Enter message here..."
                value={formData.message}
                onChange={handleChange}
                sx={{
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#C0C0C0",
                    backgroundColor: "none",
                    "&:hover fieldset": {
                      borderColor: "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  sx: {
                    borderRadius: "10px",
                    fontSize: "16px",
                    fontWeight: "400",
                  },
                }}
                inputProps={{ maxLength: 500 }}
              />
              <Box sx={{ display: "flex", justifyContent: "space-between"}}>
                <Typography sx={{ fontSize: "12px", textAlign: "end",  }}>(min 50 characters)</Typography>
                <Typography sx={{ fontSize: "12px", textAlign: "end",  }}>(max 500 characters)</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Box sx={{ textAlign: "end" }}>
          <Button
            disabled={isDisabled}
            variant="contained"
            sx={{
              mt: 2,
              mr: 3,
              height: 40,
              color: "#fff",
              width: "155px",
              fontSize: "16px",
              boxShadow: "none",
              fontWeight: "500",
              borderRadius: "10px",
              background: "#185CB7",
              textTransform: "none",
              "&:hover": { background: "#185CB7" },
            }}
            onClick={submitHandler}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              "Submit"
            )}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default HelpSupport;
